var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.971,
    height: 36.476,
    viewBox: "0 0 43.971 36.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18511"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12877",
    d: "M9236.576 2204.329h-10.85l-1.993 1.072-1.926 2.632v3.79l1.926 1.679 4.44.952h8.4z",
    transform: "translate(-9194.479 -2191.292)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": 879762
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 163",
    d: "M5.938-467.791A6.438 6.438 0 0 0 .7-463.239l-.2.645v25.9l.2.645a6.373 6.373 0 0 0 5.359 4.549c1 .129 31.855.129 32.854 0a6.373 6.373 0 0 0 5.361-4.552l.2-.645v-25.9l-.2-.645a6.373 6.373 0 0 0-5.361-4.552c-.887-.106-32.097-.106-32.975.003zm33.2 2.624a3.974 3.974 0 0 1 2.616 2.452c.172.516.181.706.181 3.614v3.081l-5.18.034c-5.757.034-5.55.009-6.841.628a6.339 6.339 0 0 0-2.117 9.775 6.876 6.876 0 0 0 3.253 2.1c.465.138 1.058.155 5.705.181l5.18.034v3.081c0 2.908-.009 3.1-.181 3.614a4.127 4.127 0 0 1-1.523 1.953c-1.024.688.327.637-17.743.637s-16.719.052-17.743-.637a4.127 4.127 0 0 1-1.523-1.953l-.181-.542v-25.058l.181-.542a4.01 4.01 0 0 1 2.521-2.427c.49-.138 1.557-.155 16.685-.155 14.617-.003 16.209.01 16.708.13zm2.8 15.523v3.786H37c-4.139 0-5.008-.017-5.369-.129a3.843 3.843 0 0 1-2.711-3.055 3.823 3.823 0 0 1 2.676-4.251 36.57 36.57 0 0 1 5.369-.129l4.965-.009z",
    transform: "translate(-.5 467.875)",
    style: {
      fill: "#5c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 164",
    d: "M360.559-270.657a1.288 1.288 0 0 0-.508 2.074c.336.353.774.439 1.979.4.9-.017 1.093-.052 1.291-.207a1.151 1.151 0 0 0 .568-1.067 1.151 1.151 0 0 0-.568-1.067c-.207-.155-.379-.181-1.368-.2a8.318 8.318 0 0 0-1.394.067z",
    transform: "translate(-328.807 287.684)",
    style: {
      fill: "#5c5c5c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientWallet);
export default __webpack_public_path__ + "static/media/patientWallet.6464b12e871cba57acda9cf46db79544.svg";
export { ForwardRef as ReactComponent };